export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10229.5e1ec60a.jpg";